import consts from "../consts";
import axios from "./axios";

export default {
  async init(accessToken, RefreshToken) {
    try {
      console.log("acces and refresh", accessToken, RefreshToken);

      await this.refreshToken();
    } catch {
      console.error("API ERROR");
    }
  },

  async getUserDetails() {
    try {
      const response = await axios.get(`user/me`, {
        headers: {
          "x-app-version": "v1",
        },
      });

      return response.data.user;
    } catch (error) {
      console.error("API ERROR", error);
    }
  },

  async getSlotVariationConfig() {
    try {
      const response = await axios.get("slots/fafafa/variation", {
        headers: {
          "x-app-version": "v1",
        },
      });
      return response.data.data.variation;
    } catch (error) {
      console.error("API ERROR", error);
    }
  },

  async spin({ chosenLines = 20, betAmount = 1, buyBonus = false } = {}) {
    betAmount = String(betAmount);

    try {
      const response = await axios.post(
        "slots/panda/play",
        {
          chosenLines,
          betAmount,
          buyBonus,
          variation: consts.game.variationName,
        },
        {
          headers: {
            "x-app-version": "v1",
          },
        }
      );

      if (!response || !response.data) return false;

      return response.data;
    } catch (err) {
      console.error("slot.spin network/error", err);
    }
  },

  async refreshToken() {
    const response = await axios.put(
      `auth/refresh`,
      {
        refreshToken: window.localStorage.getItem("refreshToken"),
        platform: "WEB",
      },
      {
        headers: {
          "x-app-version": "v1",
        },
      }
    );

    try {
      window.localStorage.setItem("accessToken", response.data.token);
      window.localStorage.setItem("refreshToken", response.data.refreshToken);
    } catch {
      console.error("Refresh token error");
    }
  },
};

/* *Turn den kalanlar *

  async facebookLogin(fbAccessToken) {
    const response = await axios.post("/auth/facebook", {
      token: fbAccessToken,
    });
    try {
      window.localStorage.setItem("accessToken", response.data.access.token);
      window.localStorage.setItem("refreshToken", response.data.refresh.token);

      await this.refreshToken();
    } catch {
      console.error("API ERROR");
      return false;
    }
  },

  async googleLogin(token) {
    const response = await axios.post("/auth/google", {
      token,
    });
    try {
      window.localStorage.setItem("accessToken", response.data.access.token);
      window.localStorage.setItem("refreshToken", response.data.refresh.token);

      await this.refreshToken();
    } catch {
      console.error("API ERROR");
      return false;
    }
  },

  async appleLogin({ token }) {
    const response = await axios.post("/auth/apple", {
      token,
    });
    try {
      window.localStorage.setItem("accessToken", response.data.access.token);
      window.localStorage.setItem("refreshToken", response.data.refresh.token);

      await this.refreshToken();
    } catch {
      console.error("API ERROR");
      return false;
    }
  },

  async fbInstantLogin({ token }) {
    const response = await axios.post("/auth/fbinstant", {
      token,
    });

    try {
      window.localStorage.setItem("accessToken", response.data.access.token);
      window.localStorage.setItem("refreshToken", response.data.refresh.token);

      await this.refreshToken();
    } catch {
      console.error("API ERROR");
      return false;
    }
  },
*/
